import ActionsPage from 'components/ActionsPages/ActionsPage';
import { SwitchQueries } from './SwitchQueries';

export const ActionsPageQueries = () => (
  <ActionsPage title="Gestión de consultas" switchAction={<SwitchQueries />} />
);
